var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageCount)?_c('div',{staticClass:"pdf-paginator d-none d-xl-flex"},[[_vm._v("\n    "+_vm._s(_vm.value)+" / "),_c('span',[_vm._v(_vm._s(_vm.pageCount))])]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }